<template>
    <FilterFlyout
        :name="$t('results.filtering.lenders')"
        :isActive="filterActive"
        :isModified="filterModified"
        @save="save"
        @clear="clear"
    >
        <div class="row lenders">
            <div class="col-4" v-for="(lender, index) in offerResultDataFilters.lenders" :key="index">
                <button
                    :class="['btn button bordered image-button', { active: lenderSelected(lender) }]"
                    @click="toggleLenderSelected(lender)"
                >
                    <i class="fad fa-check-square"></i>
                    <img v-if="lender.logo.url" :src="lender.logo.url" :alt="lender.name" />
                    <span v-else>{{ lender.name }}</span>
                </button>
            </div>
        </div>
    </FilterFlyout>
</template>

<script>
import { useStore, mapGetters } from 'vuex'
import useFilterBase from '@js/composables/filterBase.js'

// lodash components
import isEqual from 'lodash/isEqual'
import indexOf from 'lodash/indexOf'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import find from 'lodash/find'

export default {
    setup() {
        const store = useStore()

        return {
            store,
            ...useFilterBase(store),
        }
    },

    data() {
        return {
            editingLenders: [],
            activeLenders: [],
        }
    },

    mounted() {
        this.filterState.save = this.save
        this.filterState.clear = this.clear
        this.filterState.filterItem = this.filterItem
    },

    computed: {
        ...mapGetters(['offerResultDataFilters']),
        filterModified() {
            this.filterState.isModified = !isEqual(this.activeLenders, this.editingLenders)
            return this.filterState.isModified
        },
        filterActive() {
            this.filterState.isActive = !isEmpty(this.activeLenders)
            return this.filterState.isActive
        },
    },

    methods: {
        filterItem(offer) {
            return find(this.activeLenders, function (lender) {
                return offer.lender.id === lender.id
            })
        },
        toggleLenderSelected(lender) {
            const index = indexOf(this.editingLenders, lender)
            if (index >= 0) {
                this.editingLenders.splice(index, 1)
            } else {
                this.editingLenders.push(lender)
            }
        },
        lenderSelected(lender) {
            return indexOf(this.editingLenders, lender) >= 0
        },
        save() {
            this.activeLenders = cloneDeep(this.editingLenders)

            this.trackEvent('event', {
                eventCategory: 'filtering',
                eventAction: 'submit',
                eventLabel: 'lenders',
            })
        },
        clear() {
            this.editingLenders = []
            this.save()
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/gutter-size';
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/settings/variables';

.lenders {
    @include resize-gutter(10px);
    margin-bottom: -10px;

    .image-button {
        position: relative;
        height: 60px;
        padding: 5px;
        margin-bottom: 10px;
        font-size: rem(10px);
        border-color: #e0e1e5;
        background: transparent;

        .fa-check-square {
            position: absolute;
            right: -7px;
            top: 5%;
            transform: translateY(-50%); /* Adjust for proper vertical centering */
            font-size: 20px;
            color: $color-white;
            --fa-secondary-color: #{$color-primary};
            --fa-secondary-opacity: 1;
            visibility: hidden; /* Only show when active */
        }

        img {
            height: 100%;
            width: 100%;
            object-fit: contain;
            position: relative;
            overflow: hidden;

            /* Chrome-specific bugfix: this displays the alt text over broken image block when image is missing */
            &[alt]:after {
                display: flex;
                align-items: center;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #fff;
                text-align: center;
                content: attr(alt);
            }
        }

        &.active {
            border: 2px solid $color-primary;

            .fa-check-square {
                visibility: visible;
            }
        }
    }
}
</style>
